import { Injectable } from '@angular/core';

/**
 * Native localStorage wrapper service.
 * Replaces the deprecated `angular-2-local-storage` package.
 * Provides get, set, remove, and clearAll operations with a configurable prefix.
 */
@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private prefix = 'ggk';

  private prefixKey(key: string): string {
    return this.prefix ? `${this.prefix}-${key}` : key;
  }

  get<T = any>(key: string): T | null {
    const prefixedKey = this.prefixKey(key);
    const item = localStorage.getItem(prefixedKey);
    if (item === null) {
      return null;
    }
    try {
      return JSON.parse(item) as T;
    } catch {
      return item as unknown as T;
    }
  }

  set(key: string, value: any): boolean {
    try {
      const prefixedKey = this.prefixKey(key);
      localStorage.setItem(prefixedKey, JSON.stringify(value));
      return true;
    } catch {
      return false;
    }
  }

  add(key: string, value: any): boolean {
    return this.set(key, value);
  }

  remove(key: string): boolean {
    try {
      const prefixedKey = this.prefixKey(key);
      localStorage.removeItem(prefixedKey);
      return true;
    } catch {
      return false;
    }
  }

  clearAll(): boolean {
    try {
      // Only clear items with our prefix
      const keysToRemove: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith(this.prefix + '-')) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach(key => localStorage.removeItem(key));
      return true;
    } catch {
      return false;
    }
  }
}
